import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateTextImageSplit(section, img, number, line, hr, textLines, buttons) {

  // Inidividual tweens
  // Vertical red line (home)
  let lineTween = line ? gsap.to(line, {
    duration: 0.5, 
    opacity: 1, 
    height: "80%"
  }) : null;
    
  // Big section image
  let imgTween = img ? gsap.to(img, {
    duration: 0.8,
    opacity: 1, 
    ease: "power1.in"
  }) : null;
    
  // BG number image
  let numberTween = number ? gsap.to(number, {
    duration: 0.4, 
    x: 0, 
    opacity: 1
  }) : null;
    
  // Animated HR
  let hrTween = hr ? gsap.to(hr, {
    duration: 0.4, 
    width: "100%", 
    opacity: 1
  }) : null;
    
  // Animated lines of text
  let textLinesTween = textLines ? gsap.to(textLines, {
    duration: 0.8,
    y: 0,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;
    
  // Buttons div
  let buttonsTween = buttons ? gsap.to(buttons, {
    x: 0,
    opacity: 1,
    duration: 0.25,
  }) : null;

  // Timeline
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 90%",
    },
  });

  tl
    .add(lineTween)
    .add(imgTween)    
    .addLabel("imgIn", "-=0.75")
    .add(numberTween, "imgIn")
    .addLabel("startText", "-=0.2")
    .add(hrTween, "startText")
    .add(textLinesTween, "startText")
    .add(buttonsTween, "-=0.2");
}